var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("section", { attrs: { id: "content" } }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-md-9", attrs: { id: "main" } }, [
              _c("div", { staticClass: "container shortcode travel-ideas" }, [
                _c("h1", { staticClass: "idea-title" }, [
                  _vm._m(0),
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.titleinfo[_vm.getCurrentLocale]) +
                      "\n                        "
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("br"),
              _vm._v(" "),
              _c("div", { staticClass: "booking-information sdr-box" }, [
                _c("h4", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.servicesonboard_h4_1[_vm.getCurrentLocale]
                    ),
                  },
                }),
                _vm._v(" "),
                _c("p", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.servicesonboard_p_1[_vm.getCurrentLocale]
                    ),
                  },
                }),
                _vm._v(" "),
                _c("p", [
                  _vm._v(
                    "\n                            " +
                      _vm._s(_vm.meal_text2[_vm.getCurrentLocale]) +
                      "\n                            "
                  ),
                  _c(
                    "a",
                    {
                      staticStyle: {
                        "font-size": "15.9996px",
                        color: "#D6254D",
                      },
                      attrs: {
                        href: "https://www.sundair.com/downloads/Sundair-Bord-Bistro_and_Travel-Value.pdf",
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(
                          _vm.furtherservices_seat_here[_vm.getCurrentLocale]
                        )
                      ),
                    ]
                  ),
                  _vm._v(".\n                        "),
                ]),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "sidebar col-md-3" },
              [_c("sdr-aboutsundair-box"), _vm._v(" "), _c("sdr-contact-box")],
              1
            ),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _c("sdr-promobox"),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "index" }, [
      _c("i", { staticClass: "soap-icon-star circle" }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }